import React, { useEffect, useLayoutEffect, useState } from 'react';

import EcgLoader from '../../legacy/containers/EcgLoader/EcgLoader';

const style = {
  position: 'relative',
  top: '100px',
};
function MicroFrontend({ name, host, history, token, userstate, app }) {
  const [loadstate, setloadstate] = useState(false);

  const [IsRendered, setIsRendered] = useState(false);

  const renderMicroFrontend = () => {
    window[`render${name}`](`${name}-container`, history, userstate, app);
    setIsRendered(true);
  };

  useEffect(() => {
    const scriptId = `micro-frontend-script-${name}`;

    if (
      localStorage.getItem('scripload') !== null &&
      localStorage.getItem('scripload') === 'true' &&
      !IsRendered
    ) {
      if (document.getElementById(scriptId)) {
        renderMicroFrontend();
        setloadstate(true);
        return;
      }
    }
    fetch(`${host}/asset-manifest.json`)
      .then(res => res.json())
      .then(manifest => {
        const script = document.createElement('script');
        script.id = scriptId;
        script.crossOrigin = '';
        script.name = new Date().getUTCMilliseconds();
        script.src = `${host}${manifest.files['main.js']}`;
        const elementId = 'telekardiaCss';
        if (!document.getElementById(elementId)) {
          const link = document.createElement('link');
          link.id = elementId;
          link.rel = 'stylesheet';
          link.type = 'text/css';
          link.href = `${process.env.REACT_APP_TELEKARDIA_HOST}/static/css/main.css`;
          link.media = 'all';
          script.appendChild(link);
        }
        script.onload = () => {
          if (!IsRendered) {
            localStorage.setItem('scripload', true);
            renderMicroFrontend();
            setloadstate(true);
          }
        };
        document.head.appendChild(script);
      });
  }, []);

  useLayoutEffect(() => {
    return () => {
      window[`unmount${name}`] && window[`unmount${name}`](`${name}-container`);
      setIsRendered(false);
    };
  }, []);

  let browser;
  if (
    navigator.userAgent.indexOf('MSIE') !== -1 ||
    !!document.documentMode === true
  )
    browser = { name: 'ie' };
  else browser = { name: 'notie' };
  const ecgloader = loadstate ? (
    <div />
  ) : (
    <div style={style}>
      <EcgLoader browser={browser} />
    </div>
  );

  return (
    <div>
      <main id={`${name}-container`} />
      {ecgloader}
    </div>
  );
}

MicroFrontend.defaultProps = {
  document,
  window,
};

export default MicroFrontend;



// WEBPACK FOOTER //
// ./src/telekardia/components/MicroFrontend.jsx